
// Global bootstrap css
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-icons/font/bootstrap-icons.css"

//fortawesome
import '@fortawesome/fontawesome-svg-core/styles.css'

// core styles are required for all packages
import "@mantine/core/styles.css"
import "@mantine/dates/styles.css"
import "@mantine/dropzone/styles.css"
// import "@mantine/code-highlight/styles.css"

// Import global styles with Tailwind
import "@/styles/globals.css"

import Head from "next/head"

import { SessionProvider } from "next-auth/react"
import { createTheme, MantineProvider } from "@mantine/core"
//import { Analytics } from "@vercel/analytics/react"


const theme = createTheme({
    fontFamily: "Trebuchet MS",
    defaultRadius: "md",
    colors: {
      oceanblue: [
        "#e7f8ff",
        "#d9e9f7",
        "#b3d1e8",
        "#8bb8da",
        "#69a2cd",
        "#5495c6",
        "#468ec4",
        "#367bad",
        "#2a6d9c",
        "#135f8b"
      ],
      blueid: [
        "#0000ff",
        "#0000e6",
        "#0000cc",
        "#0000b3",
        "#000099",
        "#000080",
        "#000066",
        "#00004c",
        "#000033",
        "#000019"
      ],
    },
    cursorType: "pointer",
    defaultGradient: {
      from: "#0000ff",
      to: "#6666ff",
      deg: 45,
    },
    shadows: {
      xs: "1px 1px 1px rgba(0, 0, 0, .25)",
      md: "1px 1px 3px rgba(0, 0, 0, .25)",
      xl: "5px 5px 3px rgba(0, 0, 0, .25)",
    },
    other: {
      white: "#f5f5f5", 
      kai: "#1572e8"
    },
})


export default function App(
    { Component, pageProps: { session, ...pageProps } }
) {

  return (
      <MantineProvider theme={theme}>
          <SessionProvider session={session}>
              <Head>
                  <title>Wokibi</title>
                  <link rel="icon" type="image/png" sizes="32x32" href="/brand/wokibi/logotipo-white.svg"/>
              </Head>
              <Component {...pageProps} />
              {/* <Analytics /> */}
          </SessionProvider>
      </MantineProvider>
  )
}
